/**
 * 存在部分文案 英文不同，但是中文相同
 * 所以会存在 重复的中文，但是不能合并
 */

export default {
  dbi_store_rank_visualis_card_title_single: '排名趋势',
  dbi_store_rank_visualis_card_title_multipe: '市场份额分布',
  dbi_store_rank_tables_search_placeholder: '搜索任何时间，比如2022-04-04',
  dbi_store_rank_top_free: '免费榜',
  dbi_store_rank_top_free_10: '免费榜(#1-10)',
  dbi_store_rank_top_grossing: '收入榜',
  dbi_store_rank_top_paid: '付费榜',
  dbi_store_rank_top_popular: '热游榜',
  dbi_store_rank_top_new_free: '免费新游榜',
  dbi_store_rank_top_new_paid: '付费新游榜',
  dbi_top_rank_wechat_popularity: '人气榜',
  dbi_top_rank_wechat_bestseller: '畅销榜',
  dbi_top_rank_wechat_most_played: '畅玩榜',
  dbi_top_rank_wechat_popularity_30d_avg: '(人气榜)30天平均排名',
  dbi_top_rank_wechat_bestseller_30d_avg: '(畅销榜)30天平均排名',
  dbi_top_rank_wechat_most_played_30d_avg: '(畅玩榜)30天平均排名',
  dbi_top_rank_wechat_popularity_wechat: '微信小游戏人气榜',
  dbi_top_rank_wechat_bestseller_wechat: '微信小游戏畅销榜',
  dbi_top_rank_wechat_most_played_wechat: '微信小游戏畅玩榜',
  dbi_top_rank_douyin_popularity: '热门榜',
  dbi_top_rank_douyin_bestseller: '畅销榜',
  dbi_top_rank_douyin_fresh_game: '新游榜',
  dbi_top_rank_douyin_popularity_30d_avg: '(热门榜)30天平均排名',
  dbi_top_rank_douyin_bestseller_30d_avg: '(畅销榜)30天平均排名',
  dbi_top_rank_douyin_fresh_game_30d_avg: '(新游榜)30天平均排名',
  dbi_top_rank_douyin_popularity_douyin: '抖音小游戏热门榜',
  dbi_top_rank_douyin_bestseller_douyin: '抖音小游戏畅销榜',
  dbi_top_rank_douyin_fresh_game_douyin: '抖音小游戏新游榜',
  dbi_wechat_top_for_day: '霸榜{dayNum}天',
  dbi_wechat_new_entry: '新进榜',
  dbi_wechat_gravity_engine: '引力引擎',
  dbi_wechat_sorted_by_rank: '排名',
  dbi_store_rank_top_sellers: '热销榜',
  dbi_store_rank_most_played: '热玩榜',
  dbi_store_rank_new_and_trending: '热门新游榜',
  dbi_store_rank_top_wish_lists: '愿望单榜',
  dbi_store_rank_best_rated: '评价榜',
  dbi_store_rank_best_selling: '畅销榜',
  dbi_store_rank_most_downloaded: '下载榜',
  dbi_store_rank_new_games: '新游榜',
  dbi_store_rank_coming_soon: '即将上线游戏榜',
  dbi_store_rank_indies_games: '独立游戏',
  dbi_store_rank_free_to_play: '免费游戏',
  dbi_store_rank_ps5_most_downloaded: 'PS5下载榜',
  dbi_store_rank_ps4_most_downloaded: 'PS4下载榜',
  dbi_store_rank_vr_games: 'VR游戏',
  dbi_store_rank_new_release: '新游榜',
  dbi_store_rank_upcoming: '即将上线游戏榜',
  dbi_store_rank_best_sellers: '畅销榜',
  dbi_store_rank_mini_game_wechat_detail: 'Mini-game Ranking WeChat_Detail',
  dbi_store_rank_mini_game_douyin_detail: 'Mini-game Ranking Douyin_Detail',

  dbi_store_rank_no_data_under_current_selections: '当前筛选条件下无数据。',
  dbi_store_rank_last_updated_on: '最后更新于{date}',
  dbi_store_rank_no_data_only_daily: '仅提供日粒度数据。',
  dbi_store_rank_mobile_global_region: '移动游戏全球/地区',
  dbi_store_rank_all_top_charts: '全部榜单',
  dbi_store_rank_wechat_games: '微信小游戏',
  dbi_store_rank_douyin_games: '抖音小游戏',
  dbi_store_rank_global_compare: '全球对比',
  dbi_store_rank_mobile_top_more_title: '榜单详情',

  dbi_store_rank_mobile_top_title_metric_tips:
    '游戏按当前指标默认排序，请仅选择所选信息的项目：{topName} 了解更多',
  dbi_store_rank_sectional_title_metric_tips:
    '表中的数字代表游戏进入排行榜Top{rangeName}的国家数量。',
  dbi_store_rank_current_order_desc_sectional_title_metric_tips:
    '条目按国家个数降序排列。',
  dbi_store_rank_current_order_asc_sectional_title_metric_tips:
    '条目按国家个数升序排列。',
  dbi_store_rank_mobile_top_title_tips1:
    '免费榜是App Store下载量最高的免费应用程序榜单。',
  dbi_store_rank_mobile_top_title_tips2:
    '收入榜是App Store应用程序内收入最高的应用程序榜单。',
  dbi_store_rank_mobile_top_title_tips3:
    '付费榜是App Store下载量最高的付费应用程序榜单。',
  dbi_store_rank_mobile_top_title_tips4:
    '免费榜是Google Play下载量最高的免费应用程序榜单。',
  dbi_store_rank_mobile_top_title_tips5:
    '收入榜是Google Play应用程序内收入最高的应用程序榜单。',
  dbi_store_rank_mobile_top_title_tips6:
    '付费榜是Google Play下载量最高的付费应用程序榜单。',

  dbi_wechat_popularity_more_title_tips:
    '基于游戏的用户新增规模与增长速度等指标综合计算（每日更新）。',
  dbi_wechat_popularity_30d_avg_more_title_tips:
    '该游戏过去 30 天在“人气榜”中排名的平均值。',
  dbi_wechat_bestseller_more_title_tips:
    '基于游戏的用户活跃度与有效付费（内购流水）等指标综合计算（每日更新）。',
  dbi_wechat_bestseller_30d_avg_more_title_tips:
    '该游戏过去 30 天在“畅销榜”中排名的平均值。',
  dbi_wechat_most_played_more_title_tips:
    '基于游戏的用户活跃度与广告变现效果等指标综合计算（每日更新）。',
  dbi_wechat_most_played_30d_avg_more_title_tips:
    '该游戏过去 30 天在“畅玩榜”中排名的平均值。',

  dbi_douyin_popularity_more_title_tips:
    '基于游戏的用户新增规模与增长速度等指标综合计算（每日更新）。',
  dbi_douyin_popularity_30d_avg_more_title_tips:
    '该游戏过去 30 天在“人气榜”中排名的平均值。',
  dbi_douyin_bestseller_more_title_tips:
    '基于游戏的用户活跃度与有效付费（内购流水）等指标综合计算（每日更新）。',
  dbi_douyin_bestseller_30d_avg_more_title_tips:
    '该游戏过去 30 天在“畅销榜”中排名的平均值。',
  dbi_douyin_fresh_game_more_title_tips:
    '基于近期上线游戏的用户增长、活跃度及早期市场表现等指标综合计算（每日更新）。',
  dbi_douyin_fresh_game_30d_avg_more_title_tips:
    '该游戏过去 30 天在“新游榜”中排名的平均值。',

  dbi_store_rank_mobile_global_compare_country_column_tips:
    '默认情况下，国家按字母升序排列。如果选择 "全球 "或 "全球（中国大陆除外）"，则表格会固定显示前 12 个或前 11 个热门国家。',
  dbi_store_rank_mobile_global_compare_top_20_countries_tips:
    '该游戏在{num} 个国家排名前 20（所选国家）',

  dbi_store_rank_weeks: '周',
  dbi_store_rank_price$: '价格（美元）',
  dbi_store_rank_pc_pc_global: 'PC游戏全球',
  dbi_store_rank_pc_steam: 'Steam',
  dbi_store_rank_pc_epic_games: 'Epic Games',
  dbi_store_rank_pc_top_steam_top_sellers_sub_title: '相关国家数据在下钻页',
  dbi_store_rank_pc_peak_today: '今日峰值',
  dbi_store_rank_pc_top_title_tips_week: '进入前 100 名的周数',
  dbi_store_rank_pc_top_title_tips_price: '此游戏的今日价格。',
  dbi_store_rank_pc_top_title_tips1:
    '商店排名 - 最畅销游戏： Steam 上最畅销的游戏。',
  dbi_store_rank_pc_top_title_tips2:
    '商店排名 - 今日峰值： 过去 24 小时内同时参与此游戏的最高玩家人数。',
  dbi_store_rank_pc_top_title_tips3: 'Top sellers榜单是Epic平台畅销游戏榜单。',
  dbi_store_rank_pc_top_title_tips4: 'Top Popular榜单是Epic平台热门游戏榜单',
  dbi_store_rank_pc_top_title_info1:
    '条目默认按此指标升序排列，请仅选择所选信息的条目。',
  dbi_store_rank_pc_no_provide_game_details_tips:
    '我们不提供游戏硬件的详细信息。',

  dbi_store_rank_console_console_region: '主机游戏地区',
  dbi_store_rank_console_playstation: 'PlayStation',
  dbi_store_rank_console_pc: 'PC',
  dbi_store_rank_console_pc_steam: 'PC(Steam)',
  dbi_store_rank_console_xbox: 'Xbox',
  dbi_store_rank_console_nintendo: 'Nintendo',
  dbi_store_rank_console_top_title_tips1:
    'Most played榜单是Xbox平台游戏登录最多的游戏榜单。',
  dbi_store_rank_console_top_title_tips2:
    'New release榜单是Xbox平台热门新游榜单。',
  dbi_store_rank_console_top_title_tips3:
    'Upcoming榜单是Xbox平台即将上线热门游戏榜单。',
  dbi_store_rank_console_top_title_tips4:
    'Best Sellers榜单是Nintendo平台畅销游戏榜单。',
  dbi_store_rank_console_top_title_tips5:
    'New Release榜单是Nintendo平台热门新游榜单。',
  dbi_store_rank_console_top_title_tips6:
    'Coming Soon榜单是Nintendo平台即将上线热门游戏榜单。',

  dbi_store_rank_single_country_select_footer_btn_text: '跳转多国家页面',

  dbi_store_rank_view_store_rank_top_charts: '查看商店排名榜单',
};
